import { render } from "./BakaTernakan.vue?vue&type=template&id=49449744"
import script from "./BakaTernakan.vue?vue&type=script&lang=js"
export * from "./BakaTernakan.vue?vue&type=script&lang=js"

import "./BakaTernakan.vue?vue&type=style&index=0&id=49449744&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__